// extracted by mini-css-extract-plugin
export default {"item":"payment-method-item_item__0BfHt","name":"payment-method-item_name__ZLmuH","description":"payment-method-item_description__iAy+9","active":"payment-method-item_active__Yw2-S"};